var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "multitag" }, [
    _c(
      "div",
      { staticClass: "desktop-layout" },
      [
        _c("desktop-layout", {
          attrs: {
            "disable-close": _vm.disableClose,
            tags: _vm.sortedMultitag,
            "i18n-field-value": _vm.i18nFieldValue,
            "get-action-mutate": _vm.getActionMutate,
            "is-joor-action-tag": _vm.isJoorActionTagFn,
            "custom-setting": _vm.customSetting,
          },
          on: {
            close: function ($event) {
              return _vm.$emit("close")
            },
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "mobile-layout" },
      [
        _c("mobile-layout", {
          attrs: {
            "disable-close": _vm.disableClose,
            tags: _vm.sortedMultitag,
            "i18n-field-value": _vm.i18nFieldValue,
            "get-action-mutate": _vm.getActionMutate,
            "is-joor-action-tag": _vm.isJoorActionTagFn,
            "custom-setting": _vm.customSetting,
          },
          on: {
            close: function ($event) {
              return _vm.$emit("close")
            },
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }